import { AIUsageDashboardProvider } from "../../../providers/Dashboards/AIUsageDashboardProvider";
import AIUsageDashboard from "./AIUsageDashboard";

const AIUsageDashboardPage = () => {
  return (
    <AIUsageDashboardProvider>
      <AIUsageDashboard />
    </AIUsageDashboardProvider>
  );
};

export default AIUsageDashboardPage;
